import { configureStore, useAppDispatch, useAppSelector } from './store';

const store = configureStore();

export { store, useAppDispatch, useAppSelector };
